import {
  Box,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  IconButton,
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
// import AccordionSummary from "@mui/material/AccordionSummary";
import {
  DataGrid,
  GridCellParams,
  gridClasses,
  GridRenderCellParams,
  GridHeader,
} from '@mui/x-data-grid';
import vendorStatus from 'assets/icons/vendorStatus.png';
import CardHeaderContainer from 'component/CardHeaderContainer/CardHeaderContainer';
import LineChart from 'component/Chart/LineChart';
import { listview, vendorCard, vendorTop } from './Offeractivity.style';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { color, style } from 'd3';
import { border, fontFamily } from '@mui/system';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertSharpIcon from '@mui/icons-material/MoreVertSharp';
import { useTheme } from '@emotion/react';
import ManageOffer from 'component/BuyerRegistration/ManageOffer';
import { Button } from 'antd';
import NameTooltip from 'component/Common/NameTooltip';

const RightArrow = () => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M10 7L15 12L10 17"
          stroke="#000000"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{' '}
      </g>
    </svg>
  );
};

function Offeractivity({
  vendor,
  getListInfo,
  offerdata,
  tablerow,
  getdata,
  openhistory,
  buyerRegisterTableData,
  vendorDatas,
  timerStatus,
  isStageTwo,
  isWinner,
}) {
  const [listviews, setListviews] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [manageOffer, setManageOffer] = useState(false);
  const [buyerId, setBuyerId] = useState('');
  const [offerUniqueId, setOfferUniqueId] = useState(false);
  const [vendorStatusval, setVendorStatusval] = useState(false);
  const [potraitMode, setPotraitMode] = useState(false);
  const { realTimeLog } = useContext(datacontext);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down(1000));
  const [viewAllOffer, setViewAllOffer] = useState(false);
  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));

  // useEffect(() => {
  //   getdata();
  // }, [realTimeLog]);

  const Alert = ({ color }) => {
    return (
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_668_108590)">
          <path
            d="M14.7465 12.051L9.17197 2.39555C8.86199 1.85866 8.30679 1.53809 7.68678 1.53809C7.06679 1.53809 6.51156 1.85866 6.20158 2.39555L0.627035 12.051C0.31703 12.5879 0.31703 13.229 0.627035 13.7659C0.937041 14.3028 1.49222 14.6234 2.11223 14.6234H13.2613C13.8813 14.6234 14.4365 14.3028 14.7465 13.7659C15.0565 13.229 15.0565 12.5879 14.7465 12.051ZM14.0066 13.3387C13.851 13.6081 13.5724 13.769 13.2613 13.769H2.11223C1.80111 13.769 1.52253 13.6081 1.367 13.3387C1.21147 13.0693 1.21147 12.7477 1.367 12.4782L6.9416 2.8228C7.09713 2.55339 7.37572 2.39256 7.6868 2.39256C7.99786 2.39256 8.27648 2.55339 8.43201 2.8228L14.0066 12.4782C14.1621 12.7477 14.1621 13.0693 14.0066 13.3387Z"
            fill={color}
          />
          <path
            d="M8.11226 5.80273H7.25781V10.075H8.11226V5.80273Z"
            fill={color}
          />
          <path
            d="M7.68684 10.9297C7.37273 10.9297 7.11719 11.1852 7.11719 11.4993C7.11719 11.8134 7.37273 12.069 7.68684 12.069C8.00092 12.069 8.25649 11.8134 8.25649 11.4993C8.25649 11.1852 8.00094 10.9297 7.68684 10.9297Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_668_108590">
            <rect
              width="14.5845"
              height="14.5845"
              fill="white"
              transform="translate(0.394531 0.789062)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };

  const ToggleOff = () => {
    return (
      <svg
        width="42"
        height="25"
        viewBox="0 0 42 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.459961"
          y="0.370483"
          width="41.54"
          height="24.3705"
          rx="12.1852"
          fill="#DFDFDF"
        />
        <ellipse
          cx="12.981"
          cy="12.5557"
          rx="8.52103"
          ry="8.86199"
          fill="white"
        />
      </svg>
    );
  };
  const ToggleOn = () => {
    return (
      <svg
        width="42"
        height="25"
        viewBox="0 0 42 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.460938"
          width="41.54"
          height="24.3705"
          rx="12.1852"
          fill="url(#paint0_linear_9124_97512)"
        />
        <ellipse
          cx="30.0913"
          cy="12.1852"
          rx="8.52103"
          ry="8.86199"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_9124_97512"
            x1="12.7341"
            y1="-1.66162"
            x2="18.2578"
            y2="28.3495"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#6C2AD2" />
            <stop offset="1" stop-color="#77CFFE" />
          </linearGradient>
        </defs>
      </svg>
    );
  };

  const ToggeleIconViewType = () => {
    return (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_33347_144768)">
          <path
            d="M18.3425 5.75H16.1L19.78 9.6485L22.793 5.75H20.746C20.746 2.4265 18.5725 0 14.95 0V2.415C17.365 2.415 18.3425 3.749 18.3425 5.75ZM1.15002 1.15H12.65V11.5H23V23H6.90002V17.25H1.15002V1.15ZM2.02947 2.02941V16.2353H6.90002V11.5H11.8383V2.02941H2.02947ZM7.77947 12.5147V21.9853H21.9854V12.5147H7.77947Z"
            fill="#007AFF"
          />
        </g>
        <defs>
          <clipPath id="clip0_33347_144768">
            <rect width="23" height="23" fill="red" />
          </clipPath>
        </defs>
      </svg>
    );
  };

  const columns = [
    // { field: "id", headerName: "id", width: 150 },
    {
      field: 'Name',
      headerName: 'Name',
      flex: 1.3,
      headerClassName: 'super-app-theme--header',
      headerAlign: 'left',
      type: 'string',

      cellClassName: () => 'super-app',

      // ✅ IMPORTANT: extract string for sorting
      valueGetter: (params) => {
        const val = params.row.Name;

        // If already string
        if (typeof val === 'string') return val;

        // If JSX → extract text
        if (val?.props?.children) {
          const children = val.props.children;

          // Handles: ["Buyer", " ", "Tvk"]
          if (Array.isArray(children)) {
            return children
              .map((c) => (typeof c === 'string' ? c : ''))
              .join('');
          }

          return typeof children === 'string' ? children : '';
        }

        return '';
      },

      renderCell: (params) => {
        const name = params.value || '';

        return (
          <Box
            sx={{
              textAlign: 'left',
              width: '100%',
              minWidth: 0,
              overflow: 'hidden',
            }}
          >
            <NameTooltip name={name}>
              <Box
                sx={{
                  width: '100%',
                  minWidth: 0,
                  overflow: 'hidden',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: '12px',
                    fontWeight: 400,
                    color: '#112347',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%',
                    minWidth: 0,
                    cursor: 'pointer',
                  }}
                >
                  {name}
                </Typography>
              </Box>
            </NameTooltip>
          </Box>
        );
      },

      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    {
      field: 'Offer',
      headerName: 'Offer',
      headerClassName: 'super-app-theme--header',

      flex: 1,
      headerAlign: 'left',

      sortComparator: (v1, v2, cellParams1, cellParams2) => {
        const extractValue = (params) => {
          const raw = params.api.getCellValue(params.id, 'Offer');

          // raw is JSX → extract text
          if (typeof raw === 'object' && raw?.props?.children) {
            // Try to extract number from children
            const text = JSON.stringify(raw.props.children);
            const num = Number(text.replace(/[^0-9.-]+/g, ''));
            return isNaN(num) ? 0 : num;
          }

          return Number(String(raw).replace(/[^0-9.-]+/g, '')) || 0;
        };

        const val1 = extractValue(cellParams1);
        const val2 = extractValue(cellParams2);

        return val1 - val2;
      },

      renderCell: (params) => {
        return <Box sx={{ color: '#10D35E' }}>{params.value}</Box>;
      },
    },
    {
      field: 'Offer Date & Time',
      headerName: 'Offer Date & Time',
      type: 'dateTime',
      flex: 1.3,
      headerClassName: 'super-app-theme--header',

      valueGetter: (params) => {
        if (!params.value) return null;

        const [timePart, datePart] = params.value.split(' ');
        const [hours, minutes, seconds] = timePart.split(':');
        const [day, month, year] = datePart.split('-');

        return new Date(
          Number(year),
          Number(month) - 1,
          Number(day),
          Number(hours),
          Number(minutes),
          Number(seconds || 0)
        );
      },

      valueFormatter: (params) => {
        if (!params.value) return '';

        const date = params.value;

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${hours}:${minutes}:${seconds} ${day}-${month}-${year}`;
      },
    },
    {
      field: '% chng',
      headerName: '% chng',
      flex: 1,
      type: 'number',
      headerClassName: 'super-app-theme--header',
      headerAlign: 'left',

      // ✅ Custom sorting
      sortComparator: (v1, v2) => {
        const getRank = (val) => {
          if (!val || String(val).includes('_')) return 0; // lowest
          if (String(val).includes('-')) return 1; // medium
          return 2; // highest
        };

        const rank1 = getRank(v1);
        const rank2 = getRank(v2);

        // First sort by rank
        if (rank1 !== rank2) {
          return rank1 - rank2;
        }

        // If same category, sort numerically
        const num1 = Number(String(v1).replace('%', '').replace('_', '0'));
        const num2 = Number(String(v2).replace('%', '').replace('_', '0'));

        return num1 - num2;
      },

      renderCell: (params) => {
        let color;
        if (String(params.value)?.includes('-')) {
          color = 'red';
        } else if (String(params.value)?.includes('_')) {
          color = '#999';
        } else {
          color = '#10D35E';
        }

        return (
          <Box
            sx={{
              color: color,
              textAlign: 'left',
              width: '100%',
            }}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: 'Offer Type',
      headerName: 'Offer Type',
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => {
        return (
          <Box
            // sx={{
            //   color: "#10D35E",
            //   textAlign: "left",
            //   width: "100%",
            // }}
            sx={{
              // background: "rgba(237, 11, 11, 0.6)",
              background:
                params.value == 'Conditional'
                  ? 'rgba(237, 11, 11, 0.6)'
                  : 'rgba(16, 211, 94, 1)',
              color: 'white',
              borderRadius: '5px',
              width: 'auto',
              height: '22px',
              fontSize: '11px',
              padding: '4px 6px 0px 4px ',
              fontWeight: '500',
              fontFamily: 'poppins',
              marginLeft: '5px',
              marginTop: '5px',
            }}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: 'Vendor Status',
      headerName: 'Vendor Status',
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => {
        return params.value === 'No response' ? (
          <Typography paddingLeft={'58px'}>_</Typography>
        ) : (
          <Typography
            sx={{
              borderRadius: '54px',

              width: '120px',
              padding: '2px 14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '5px',

              border: '1px solid ',
              borderColor: !params.value
                ? 'rgba(243, 152, 0, 1)'
                : params.value === 'Accepted'
                ? 'rgba(16, 211, 94, 1)'
                : params.value === 'Rejected'
                ? 'rgba(249, 57, 57, 1)'
                : params.value === 'Counter Offer'
                ? 'rgba(255, 0, 255, 1)'
                : params.value === 'Private Offer'
                ? '#4CA4D6'
                : '#F93939',
            }}
          >
            <Typography>
              <Alert
                color={
                  !params.value
                    ? 'rgba(243, 152, 0, 1)'
                    : params.value === 'Accepted'
                    ? 'rgba(16, 211, 94, 1)'
                    : params.value === 'Rejected'
                    ? 'rgba(249, 57, 57, 1)'
                    : params.value === 'Counter Offer'
                    ? 'rgba(255, 0, 255, 1)'
                    : params.value === 'Private Offer'
                    ? '#4CA4D6'
                    : '#F93939'
                }
              />
            </Typography>
            <Typography
              whiteSpace={'nowrap'}
              sx={{
                fontFamily: 'poppins',
                fontWeight: 300,
                fontSize: '12px',
                color: !params.value
                  ? 'rgba(243, 152, 0, 1)'
                  : params.value === 'Accepted'
                  ? 'rgba(16, 211, 94, 1)'
                  : params.value === 'Rejected'
                  ? 'rgba(249, 57, 57, 1)'
                  : params.value === 'Counter Offer'
                  ? 'rgba(255, 0, 255, 1)'
                  : params.value === 'Private Offer'
                  ? '#4CA4D6'
                  : '#F93939',
              }}
            >
              {params.value ? params.value : 'Pending'}
            </Typography>
          </Typography>
        );
      },
    },
  ];

  const isSmallScreen = useMediaQuery('(max-width:400px)');
  const isScreenlessthan600 = useMediaQuery('(max-width:600px)');
  const [tabAlign, setTabAlign] = useState(false);

  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const displaySector = matchessm
    ? viewAllOffer
      ? offerdata
      : offerdata?.slice(-3)
    : offerdata?.slice(-15);
  return (
    <Card sx={{ ...vendorCard, borderRadius: matchessm ? '10px' : '5px' }}>
      {!openhistory && (
        <Grid sx={vendorTop}>
          {(!isScreenlessthan600 || !tabAlign) && (
            <Grid item>
              <CardHeaderContainer
                title="Offer Activity"
                icon={vendorStatus}
                sx={{ backgroundColor: '#000000' }}
              />
            </Grid>
          )}
          <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            spacing={2}
          >
            {matchessm ? (
              <Grid
                item
                sx={{ ...listview, border: '0px' }}
                onClick={() => {
                  setListviews(!listviews);
                }}
              >
                {!listviews ? <ToggleOff /> : <ToggleOn />}
                &nbsp;&nbsp;&nbsp;
                <Typography
                  sx={{
                    pr: '2px',
                    fontFamily: 'Poppins !important',
                    color: '#666666',
                    fontSize: '14px',
                  }}
                >
                  List
                </Typography>
              </Grid>
            ) : (
              <Typography
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  border: '1px solid #F0F0F0',
                  borderRadius: '5px',
                  height: '41px',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
                onClick={() => {
                  setListviews(!listviews);
                }}
              >
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                  alignItems={'center'}
                  padding={'0px 10px'}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '12px !important',
                      color: '#112347',
                    }}
                  >
                    List View:
                  </Typography>
                  <Typography sx={{ paddingTop: '8px' }}>
                    {!listviews ? <ToggleOff /> : <ToggleOn />}
                  </Typography>
                </Stack>
              </Typography>
            )}

            {isScreenlessthan600 && (
              <Grid item>
                <Box
                  //borderRadius="50%"
                  width={41}
                  height={41}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ border: '1px solid #F0F0F0', borderRadius: '5px' }}
                  onClick={() => {
                    setPotraitMode((prev) => !prev);
                  }}
                >
                  <ToggeleIconViewType />
                </Box>
              </Grid>
            )}
          </Stack>
        </Grid>
      )}
      {offerdata != null ? (
        listviews || openhistory ? (
          <Grid
            sx={{
              overflowX: 'auto',
              height: isScreenlessthan600 ? '380px' : '318px',
              border: '1px solid #E4E4E4',
              borderRadius: '5px',
              '&:hover .MuiDataGrid-virtualScroller': {
                overflowY: { xs: 'hidden', sm: 'auto' },
                overflowX: 'hidden',
              },
            }}
          >
            {isScreenlessthan600 ? (
              <DataGrid
                sx={{
                  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]:
                    {
                      outline: 'none',
                    },
                  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
                    {
                      outline: 'none',
                    },
                  [`& .${gridClasses.cellContent}`]: {
                    whiteSpace: 'wrap',
                    fontSize: '12px',
                    fontFamily: 'Poppins',
                    color: '#112347',
                  },
                  [`& .super-app-theme--header`]: {
                    fontSize: '10px',
                    fontWeight: 400,
                    fontFamily: 'Poppins',
                    color: '#666666',
                  },
                  cursor: 'pointer',
                  fontFamily: 'Poppins !important',
                  width: !matches ? '100%' : '1000px',
                  height: '368px',
                  border: 'none',
                  maxHeight: '421px',
                  [`& .MuiDataGrid-footerContainer`]: {
                    justifyContent: 'flex-start', // Align footer content to the left
                  },
                }}
                rows={tablerow}
                columns={columns}
                onRowClick={(e) => {
                  if (!openhistory) {
                    setBuyerId(e.row.buyerId);
                    setOfferUniqueId(e.row.offerUniqueId);
                    setVendorStatusval(e.row.vendorStatus);
                    setManageOffer(true);
                  }
                }}
                selectionModel={selectionModel}
                onRowSelectionModelChange={(val) => setSelectionModel(val)}
                pagination={true}
                pageSizeOptions={[5, 10, 25, 50, 100]}
                initialState={{
                  pagination: { paginationModel: { pageSize: 5 } },
                }}
              />
            ) : (
              <DataGrid
                sx={{
                  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]:
                    {
                      outline: 'none',
                    },
                  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
                    {
                      outline: 'none',
                    },
                  [`& .${gridClasses.cellContent}`]: {
                    whiteSpace: 'wrap',
                    fontSize: '12px',
                    fontFamily: 'poppins',
                    color: '#112347',
                  },
                  [`& .super-app-theme--header`]: {
                    fontSize: '10px',
                    fontWeight: 400,
                    fontFamily: 'poppins',
                    color: '#666666',
                  },
                  cursor: 'pointer',
                  fontFamily: 'poppins !important',
                  width: !matches ? '100%' : '1000px',
                  height: '318px',
                  border: 'none',
                  maxHeight: '421px',
                  '& .MuiDataGrid-virtualScroller': {
                    overflowY: { xs: 'hidden', sm: 'hidden' },
                    overflowX: 'hidden',
                    scrollbarWidth: 'thin !important',
                  },
                  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888',
                    borderRadius: '10px !important',
                  },
                  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
                    backgroundColor: '#f1f1f1',
                  },
                }}
                rows={tablerow}
                columns={columns}
                onRowClick={(e) => {
                  if (!openhistory) {
                    setBuyerId(e.row.buyerId);
                    setOfferUniqueId(e.row.offerUniqueId);
                    setVendorStatusval(e.row.vendorStatus);
                    setManageOffer(true);
                  }
                }}
                hideFooterSelectedRowCount={true}
                selectionModel={selectionModel}
                pagination={false}
                hideFooter
                onRowSelectionModelChange={(val) => setSelectionModel(val)}
              />
            )}
          </Grid>
        ) : (
          <Grid>
            <Grid sx={{ overflowX: 'auto' }}>
              <LineChart
                viewAllOffer={matchessm ? viewAllOffer : true}
                activity={true}
                sector={displaySector}
                vendor={vendor}
                getListInfo={getListInfo}
                potraitMode={potraitMode}
                tableData={buyerRegisterTableData}
                timerStatus={timerStatus}
                isStageTwo={isStageTwo}
                isWinner={isWinner}
                primaryUserTypeValue={primaryUserTypeValue}
              />
            </Grid>
            <Grid
              display={'flex'}
              justifyContent={matchessm ? 'space-between' : 'right'}
              sx={{
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              {matchessm && (
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    display: 'flex',
                    flexDirection: 'row',
                    fontSize: '12px',
                    alignItems: 'center',
                    gap: '5px',
                    cursor: 'pointer',
                    fontWeight: 400,
                  }}
                  onClick={() => {
                    setViewAllOffer(!viewAllOffer);
                  }}
                >
                  {viewAllOffer ? 'Show Less' : 'View All'} <RightArrow />
                </Typography>
              )}
              <Stack display={'flex'} flexDirection={'column'}>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: isSmallScreen && '12px',
                  }}
                >
                  <span style={{ color: 'green' }}>
                    {matchessm ? '-----' : '----------'}
                  </span>{' '}
                  Vendor Accepted
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: isSmallScreen && '12px',
                  }}
                >
                  <span style={{ color: 'red' }}>
                    {matchessm ? '-----' : '----------'}
                  </span>{' '}
                  Stage Timer 2 commenced
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: isSmallScreen && '12px',
                  }}
                >
                  <span style={{ color: 'rgba(11, 168, 218, 1)' }}>
                    {matchessm ? '-----' : '----------'}
                  </span>{' '}
                  Winning Offer
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        )
      ) : (
        <Grid
          xs={12}
          sm={12}
          lg={12}
          sx={{
            textAlign: 'center',
            fontFamily: 'poppins',
            fontWeight: 500,
            color: '#585858',
          }}
        >
          No offer history found
        </Grid>
      )}
      {manageOffer && (
        <ManageOffer
          lineChart={true}
          offerUniqueId={offerUniqueId}
          buyerId={buyerId}
          open={manageOffer}
          manageOffer={manageOffer}
          setManageOffer={setManageOffer}
          getListInfo={getListInfo}
          vendorStatus={vendorStatusval}
          moxouserId={true}
          tableData={buyerRegisterTableData}
          vendorDatas={vendorDatas}
        />
      )}
    </Card>
  );
}
export default Offeractivity;
